import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { MaterialModule } from '../material';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '../Services/auth.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [MaterialModule, RouterModule, CommonModule, TranslateModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css'
})
export class SidebarComponent implements OnInit{
  isCollapsed = false;
  isMobileView = window.innerWidth < 992;
  showLabels = true;
  sidebarData: any;
  @Output() sidebarToggled = new EventEmitter<boolean>();
  constructor(private authService:AuthService){}

  ngOnInit(): void {
   this.sidebarData= this.authService.getSidebarMenu()
  }

  toggleSidebar() {
    if (this.isMobileView) {
      return;
    }

    this.isCollapsed = !this.isCollapsed;
    this.sidebarToggled.emit(this.isCollapsed);

    if (!this.isCollapsed) {
      setTimeout(() => {
        this.showLabels = true;
      }, 300);
    } else {
      this.showLabels = false;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobileView = window.innerWidth < 992;

    if (this.isMobileView) {
      this.isCollapsed = true;
      this.showLabels = false;
      this.sidebarToggled.emit(true);
    }
  }

}
